export enum OrganismeFichierType {
  ATTESTATION_REPRESENTANT = 'ATTESTATION_REPRESENTANT',
  DELEGATION_POUVOIR = 'DELEGATION_POUVOIR',
  HABILITATION = 'HABILITATION',
}

export const ALL_ORGANISME_FICHIER_TYPES: OrganismeFichierType[] = [
  OrganismeFichierType.ATTESTATION_REPRESENTANT,
  OrganismeFichierType.DELEGATION_POUVOIR,
  OrganismeFichierType.HABILITATION,
];